import { extractRankingPayload } from '~/modules/catalogEventTracking.js';

function normalizedOptionKeys(optionKeys) {
  return Array.isArray(optionKeys) ? optionKeys.filter(Boolean) : [];
}

export function normalizeProjectLicenseSelection(selection) {
  const rawSelection = typeof selection === 'string' ? { familyKey: selection } : (selection || {});
  const familyKey = rawSelection.familyKey || rawSelection.projectLicenseFamilyKey || rawSelection.key;

  if (!familyKey) {
    return null;
  }

  const normalizedSelection = {
    project_license_flow: familyKey === 'event_track_license' ? 'event_track' : 'v2',
    project_license_family_key: familyKey,
    project_license_option_keys: normalizedOptionKeys(rawSelection.selectedOptionKeys || rawSelection.projectLicenseOptionKeys),
    customer_project_license_preset_id: rawSelection.customerProjectLicensePresetId || rawSelection.projectLicensePresetId || null,
    project_license_preset_name: rawSelection.projectLicensePresetName || null
  };

  if (familyKey === 'event_track_license') {
    normalizedSelection.customer_event_license_preset_id = rawSelection.customerEventLicensePresetId || rawSelection.eventLicensePresetId || null;
  }

  return normalizedSelection;
}

export function buildProjectLicenseCartRequestData(trackId, selection, rankingSource = {}) {
  const normalizedSelection = normalizeProjectLicenseSelection(selection);
  if (!normalizedSelection) {
    return null;
  }

  return {
    track_id: trackId,
    ...normalizedSelection,
    ...extractRankingPayload(rankingSource)
  };
}

export function buildProjectLicenseCartRemoveRequestData(trackId, selection) {
  if (!selection || !selection.usageLicenseTypeId) {
    return null;
  }

  const requestData = {
    track_id: trackId,
    usage_license_type_id: selection.usageLicenseTypeId,
    remove: true,
    project_license_option_keys: normalizedOptionKeys(selection.selectedOptionKeys || selection.projectLicenseOptionKeys),
    customer_project_license_preset_id: selection.customerProjectLicensePresetId || selection.projectLicensePresetId || null
  };

  if (selection.familyKey === 'event_track_license') {
    requestData.customer_event_license_preset_id = selection.customerEventLicensePresetId || selection.eventLicensePresetId || null;
  }

  return requestData;
}

export function buildProjectLicenseTrackingProps(trackId, selection, locationHref) {
  const normalizedSelection = normalizeProjectLicenseSelection(selection);
  if (!normalizedSelection) {
    return { track_id: trackId, location: locationHref };
  }

  const trackingProps = {
    track_id: trackId,
    project_license_family_key: normalizedSelection.project_license_family_key,
    customer_project_license_preset_id: normalizedSelection.customer_project_license_preset_id,
    location: locationHref
  };

  if (normalizedSelection.project_license_family_key === 'event_track_license') {
    trackingProps.customer_event_license_preset_id = normalizedSelection.customer_event_license_preset_id;
  }

  return trackingProps;
}
